class RequestQuote {

    doAThing() {
        console.log('animations Do a thing')

    }

    constructor(){

        $.urlParam = function (name) {
          // eslint-disable-next-line no-useless-escape
            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);

            return (results !== null) ? results[1] || 0 : false;
        }

        let product  = $.urlParam('product')

        if ($('#request-quote-form-block')[0]) {
            // Do something if class exists

            //$('.product select').val('option-2');
            $('.product select').val(product);
        }
    }
}

export default RequestQuote



// WEBPACK FOOTER //
// ./scripts/util/requestQuote.js